/**
 * The six state games of Desi Race, in the order of the old welcome.php pegs.
 * `level` is the stages.stageN column the score is stored in.
 */
export const GAMES = [
  { key: "bengal", level: 1, state: "BENGAL" },
  { key: "maharashtra", level: 2, state: "MAHARASHTRA" },
  { key: "gujarat", level: 3, state: "GUJARAT" },
  { key: "punjab", level: 4, state: "PUNJAB" },
  { key: "andhra", level: 5, state: "ANDHRA PRADESH" },
  { key: "karnataka", level: 6, state: "KARNATAKA" },
];

export const GAME_BY_KEY = Object.fromEntries(GAMES.map((g) => [g.key, g]));
export const TOTAL_GAMES = GAMES.length;

export const WELCOME_ROUTE = "/welcome";
export const THANKYOU_ROUTE = "/thankyou";
export const PLANS_URL = "https://extramileplay.com/plans";

export function gameRoute(key) {
  return `/play/${key}`;
}
